import { Ignore } from '@master/annotation/Ignore'
import { MetaClass } from '@master/annotation/MetaClass'
import { ClientInfoBase } from './ClientInfoBase'
import { ClientPersonal } from './ClientPersonal'

export const AccountTypeOptions = [
  { value: '', label: '' },
  { value: 'individual', label: 'Individual' },
  { value: 'corporate', label: 'Corporate' }
]
export const StatusOptions = [
  { value: '', label: '' },
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'terminated', label: 'Terminated' }
]
export const TitleOptions = [
  { label: '', value: '' },
  { label: 'Dr', value: 'dr' },
  { label: 'Mr', value: 'mr' },
  { label: 'Miss', value: 'miss' },
  { label: 'Mrs', value: 'mrs' },
  { label: 'Mdm', value: 'mdm' }
]
export class ClientProfile extends ClientInfoBase {
  accountType = undefined
  clientOid = undefined
  clientSince = undefined
  mobileNumber = undefined
  title = undefined
  name = undefined
  nric = undefined
  status = undefined

  @MetaClass(ClientPersonal)
  personalInfoJson = new ClientPersonal()

  casualName = undefined
  printingName = undefined
  remarks = undefined

  isAccreditedInvestor = undefined
  isOverseasInvestor = undefined
  passedCka = undefined

  ftfDateOfVerification = undefined
  ftfJobRole = undefined
  ftfPerformedBy = undefined
  ftfRemarks = undefined
  hrcRoles = []

  @Ignore()
  get accountTypeDisplay () {
    return AccountTypeOptions.find(ato => ato.value === this.accountType)?.label
  }

  @Ignore()
  get statusDisplay () {
    return StatusOptions.find(so => so.value === this.status)?.label
  }

  convertToRawData () {
    if (!this.personalInfoJson) {
      this.personalInfoJson = new ClientPersonal()
    }
    const raw = super.convertToRawData()
    raw[this.snakeCaseKey('personalInfoJson')] = JSON.stringify(this.personalInfoJson.convertToRawData())
    raw[this.snakeCaseKey('hrcRoles')] = JSON.stringify(this.hrcRoles)
    delete raw[this.snakeCaseKey('clientOid')] // clientOid is not a column
    return raw
  }
}
